import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as activityActions from '../actions/activities.action';
import * as ongoingActivityActions from '../actions/ongoing-activity.action';
import {map, switchMap} from 'rxjs/operators';
import {Utils} from "../../shared/utils/utils";
import {ActivityAction, ActivityStatus} from "../../activities/activity";
import {IWebsiteActivitiesState} from "../reducers/activities.reducer";
import * as websiteActions from "../actions/website.action";
import {ActivityNotificationService} from '../../activity-notifications/activity-notification.service';
import * as activityNotificationActions from '../actions/activity-notifications.action';
import {ActivityMapper} from '../../activities/activity-mapper';
import * as userActions from "../actions/user.action";

@Injectable()
export class ActivitiesEffects {

  constructor(
    private _actions$: Actions,
    private _activityNotificationService: ActivityNotificationService
  ) {
  }

  loadWebsitesSuccess$ = createEffect(() => this._actions$.pipe(
    ofType(websiteActions.LOAD_WEBSITES_SUCCESS),
    switchMap(() => [
        new activityNotificationActions.LoadActivityNotifications(),
        new activityNotificationActions.InitActivityNotificationsSocket()
      ])
    ));

  loadUserSuccess$ = createEffect(() => this._actions$.pipe(
    ofType(userActions.LOAD_USER_SUCCESS),
      switchMap(() => [
        new activityActions.LoadActivities(),
        new activityActions.InitActivitiesSocket()
      ])
  ));

  loadActivities$ = createEffect(() => this._actions$.pipe(
    ofType(activityActions.LOAD_ACTIVITIES),
    switchMap(() => {
      return this._activityNotificationService.getActivities()
        .pipe(
          map((activities: any[]) => {
            const websiteActivityMap: any = activities
              .reduce((websiteActivityMap: {}, activity: any) => {
                let websiteActivities: any[] = websiteActivityMap[activity.domain_id];
                if (!websiteActivities) {
                  websiteActivities = websiteActivityMap[activity.domain_id] = [];
                }
                websiteActivities.push(ActivityMapper.map(activity));

                return websiteActivityMap;
              }, {});
            const activityEntities: { [websiteId: number]: IWebsiteActivitiesState } = Object.keys(websiteActivityMap)
              .reduce((entities: { [websiteId: number]: IWebsiteActivitiesState }, websiteId: string): {
                [websiteId: number]: IWebsiteActivitiesState
              } => {
                return {
                  ...entities,
                  [websiteId]: {
                    websiteId: websiteId,
                    entities: Utils.arrayToEntities(websiteActivityMap[websiteId], 'id')
                  }
                };
              }, {});

            console.log('🏪 ActivitiesEffect: Dispatching LoadActivitiesSuccess with entities:', activityEntities);
            return new activityActions.LoadActivitiesSuccess(activityEntities);
          })
        );
    })));

  initActivitiesSocket$ = createEffect(() => this._actions$.pipe(
    ofType(activityActions.INIT_ACTIVITIES_SOCKET),
    switchMap(() => {
      return this._activityNotificationService.subscribeToActivities()
        .pipe(
          map((data: any) => {
            // TODO: to fix core bug
            if (typeof data !== "undefined" && [
              ActivityAction.INSTALL,
              ActivityAction.INSTALL_ACTIVATE,
              ActivityAction.INSTALL_ACTIVATE_UPLOAD,
              ActivityAction.UPDATE,
              ActivityAction.DEACTIVATE_DELETE,
              ActivityAction.ACTIVATE,
              ActivityAction.DEACTIVATE
            ].includes(data.action)) {
              if (data.status === ActivityStatus.RUNNING) {
                data.progress = 0;
              } else if ([ActivityStatus.DONE, ActivityStatus.FAILED].includes(data.status)) {
                data.progress = 100;
              }
            }
            // TODO: /to fix core bug

            console.log('📊 ActivitiesEffect: Processed activity data:', data);
            return data;
          }),
          switchMap(data => {
            return [
              new activityActions.AddActivity(ActivityMapper.map(data)),
              new ongoingActivityActions.UpdateOngoingActivity(ActivityMapper.map(data)),
            ];
          })
        );
    })
  ));

}
